import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

type SubMenus = "LOP" | "PROTOCOLLMANAGEMENT" | "PLAN_DELIVERY_LIST" | "RESOLUTIONS";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "PROJECT_MANAGMENT")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;

    if (subModules) {
      subModules.includes("LOP") &&
        config.push({
          label: <MenuItemWithBadge label={`LOPs`} />,
          link: "lop",
          icon: "tasks-alt",
        });
      subModules.includes("PROTOCOLLMANAGEMENT") &&
        config.push({
          label: <MenuItemWithBadge label={`Meetings`} />,
          link: "meetings",
          icon: "calendar-day",
        });
      // subModules.includes("RESOLUTIONS") &&
      //   config.push({
      //     label: <MenuItemWithBadge label={`Resolutions`} />,
      //     link: "resolutions",
      //     icon: "hand-holding-box",
      //   });
      subModules.includes("PLAN_DELIVERY_LIST") &&
        config.push({
          label: <MenuItemWithBadge label={`Plan delivery list`} />,
          link: "pdl",
          icon: "business-time",
        });
    }

    return config;
  },
};
